<template functional>
  <div
    class="grid grid-cols-6 row-gap-5 lg:row-gap-20 gap-5 text-center"
    :class="data.staticClass || ''"
    v-bind="data.attrs"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "ContentArea"
};
</script>
